var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPunish(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 54,
    height: 54,
    rx: 8,
    fill: "#FFD7D7"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_53_1240)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.6304 34.4995L40.8671 28.2628C41.3416 27.7883 41.3416 27.019 40.8671 26.5446L37.1336 22.811C36.6591 22.3365 35.8898 22.3365 35.4153 22.811L29.1786 29.0477C28.7042 29.5222 28.7042 30.2915 29.1786 30.766L32.9122 34.4995C33.3867 34.974 34.156 34.974 34.6304 34.4995Z",
    fill: "#FF0000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.3295 24.1901L30.5662 17.9534C31.0407 17.4789 31.0407 16.7096 30.5662 16.2351L26.8327 12.5016C26.3582 12.0271 25.5889 12.0271 25.1144 12.5016L18.8777 18.7383C18.4033 19.2127 18.4033 19.982 18.8777 20.4565L22.6113 24.1901C23.0858 24.6645 23.8551 24.6645 24.3295 24.1901Z",
    fill: "#FF0000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9198 40.094L34.142 21.8718C34.7219 21.2919 34.7219 20.3517 34.142 19.7717L34.0889 19.7187C33.509 19.1388 32.5688 19.1388 31.9888 19.7187L13.7667 37.9408C13.1868 38.5208 13.1868 39.461 13.7667 40.0409L13.8197 40.094C14.3996 40.6739 15.3399 40.6739 15.9198 40.094Z",
    fill: "#FF0000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.815 38.985H21.87C21.2238 38.985 20.7 39.5088 20.7 40.155V40.68C20.7 41.3262 21.2238 41.85 21.87 41.85H37.815C38.4612 41.85 38.985 41.3262 38.985 40.68V40.155C38.985 39.5088 38.4612 38.985 37.815 38.985Z",
    fill: "#FF0000"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_53_1240"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white",
    transform: "translate(9 9)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPunish);
export default __webpack_public_path__ + "static/media/punish.b1af9731ae16ec4403a20e19984f0321.svg";
export { ForwardRef as ReactComponent };